// The page's CSRF token, as rendered or as last refreshed.
export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content ?? ''
}

// Re-syncs the page's CSRF tokens (meta tag and form fields) against the current session,
// and returns the fresh one — null when the request fails. A page rendered before the
// session rotated (sign-in, NativeApiToken exchange, another native tab) carries a token
// the server now rejects with a 422.
export async function refreshCsrfToken(url = '/csrf_token') {
  const response = await fetch(url, { headers: { Accept: 'application/json' } })
  // A 2xx can still be HTML (a proxy or maintenance page): parsing it would throw.
  if (!response.ok || !response.headers.get('Content-Type')?.includes('json')) return null

  const { token } = await response.json()
  document.querySelector("meta[name='csrf-token']")?.setAttribute('content', token)
  document.querySelectorAll("input[name='authenticity_token']").forEach((input) => { input.value = token })
  return token
}
